import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ScaleNotificationMessage } from '@cloudorder/ui';

import { useAuth } from '@/shared/auth/AuthContext';

export function AdminGuard({ children }: { readonly children: ReactNode }) {
  const { user } = useAuth();
  const { t } = useTranslation('administration');
  if (user?.roles.includes('ordermanageradmin') !== true) {
    return <ScaleNotificationMessage variant="warning" opened>{t('adminOnly')}</ScaleNotificationMessage>;
  }
  return children;
}